import { dealModel, DealRecord } from "@/models/deal";
import { userIsCreatorConstraint } from "@/orm/model";
import { Entity } from "@/orm/types";
import { Button, Card, Loader, Stack, Text, TextInput } from "@mantine/core";
import { useAtomValue } from "jotai";
import { useState } from "react";
import { BiSearch } from "react-icons/bi";
import { RiFileFill } from "react-icons/ri";
import { stringSimilarity } from "string-similarity-js";

export const AddExistingDeal = ({
  onSelect,
}: {
  onSelect: (deal: Entity<DealRecord>) => void;
}) => {
  const [search, setSearch] = useState("");

  const { entities: dealEntites, loading } = useAtomValue(
    dealModel.getObserveEntitiesAtom({
      constraints: [userIsCreatorConstraint()],
    }),
  );

  // filter and search deals name and email, firm with stringSimilarity > 0.5
  // limit to 10 deals

  const filteredDeals = dealEntites
    ?.filter(({ data: contact }) => {
      if (
        stringSimilarity(search, contact?.companyName) > 0.22 ||
        stringSimilarity(search, contact?.remarks) > 0.22
      )
        return true;

      if (search.length < 3) return false;

      return (
        contact?.companyName?.toLowerCase().includes(search.toLowerCase()) ||
        contact?.remarks?.toLowerCase().includes(search.toLowerCase())
      );
    })
    .slice(0, 10)
    .sort((a, b) => {
      return (
        stringSimilarity(search, a.data.companyName) -
        stringSimilarity(search, b.data.companyName)
      );
    });

  return (
    <Stack gap={"xs"} align="center">
      <TextInput
        leftSection={<BiSearch />}
        rightSection={loading && <Loader size={16} />}
        label="Search Deals"
        value={search}
        onChange={(e) => {
          setSearch(e.currentTarget.value);
        }}
        w={"100%"}
      />

      {search.length > 2 && (
        <Card
          bg={"white"}
          p={"xs"}
          w={"100%"}
          withBorder
          mah={200}
          style={{ overflowY: "auto" }}
        >
          <Stack>
            {search.length > 1 && !loading && filteredDeals?.length === 0 && (
              <Text c="dimmed" size="sm" ta={"center"}>
                No deals found.
              </Text>
            )}

            {filteredDeals?.map((deal) => (
              <Button
                key={deal.id}
                onClick={() => onSelect(deal)}
                w={"100%"}
                variant="transparent"
                leftSection={<RiFileFill size={20} />}
                justify="flex-start"
              >
                {deal.data.companyName || "(Untitle Deal)"}
              </Button>
            ))}
          </Stack>
        </Card>
      )}
    </Stack>
  );
};
